export enum AppointmentState {
  NORMAL,
  WAITS_ON_PREMISE,
  PICKUP,
}
